import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BottomBar } from './bottomBar.jsx.js';
import { TopBarV2 } from './topBarV2.jsx.js';
import { LinearProgress } from '@material-ui/core';
import { CircleIcon } from './commonControls.jsx.js';
import * as localStorage from '../localStorage'
const Link = require('react-router-dom').Link;
import {MainPageContainerWithRouter} from "./mainPageContainer.jsx";

const drawerWidth = 290;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#4457CF'
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: '10px',
    marginLeft: '-20px'
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    height: `calc(100% - ${35}px)`,
    overflowX: 'hidden',
    backgroundColor: '#E2EEEE',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    backgroundColor: '#E2EEEE',
    height: `calc(100% - ${35}px)`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(8) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7) + 8,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  listItemText: {
    // font: 'Bold 17px/23px Roboto;',
    // font: 'Bold 17px/23px Roboto;',
    fontWeight:'600',
    color: '#4457CF',
    // marginLeft:'2em'

  },
  listItem: {
    marginBottom: '10px'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    paddingBottom: `${theme.spacing(2)+ 35}px`
    // paddingLeft: theme.spacing(1), // changes padding around main content box

  }
}));

export function TopBarAndMenuV2(props) {
  const classes = useStyles();
  const theme = useTheme();
  let menuOpen = localStorage.getItem('menuOpen');
  if(menuOpen == null){ 
    localStorage.setItem(`menuOpen`, true);
    menuOpen = 'true';
  }
  const [open, setOpen] = React.useState(menuOpen == 'true');
  const {locations, showAdmin} = props;
  const handleDrawerToggle = () => {
    localStorage.setItem(`menuOpen`, !open);
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    localStorage.setItem(`menuOpen`, false);
    setOpen(false);
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <TopBarV2 classes={classes} menuClick={handleDrawerToggle}/>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <FontAwesomeIcon icon={['fas', "bars"]} />
              : <FontAwesomeIcon icon={['fas', "bars"]} />
            }
          </IconButton>
        </div>
        <Divider />
        <List style={{ marginTop: '1em' }}>
        {locations && locations.filter(location => (location.validation == true)).map((location,i) => {
          return(
          <ListItem onClick={() => document.scrollingElement.scrollTo(0, 0)} className={classes.listItem} key={i} component={location.component} href={location.to} to={location.to} button>
            {location.icon}
            <Typography className={classes.listItemText}>{location.title}</Typography>
          </ListItem>
          )
        })}
        </List>
        {(showAdmin && window.globals.isAdmin) &&
          <div>
            <Divider />
            <List>
              <ListItem className={classes.listItem} component="a" href='/admin' button>
                <CircleIcon icon={['fas', "users-cog"]} color="gray" leftOffset="1" />
                <Typography className={classes.listItemText}>Admin Settings</Typography>
              </ListItem>
            </List>
          </div>
        }
      </Drawer>
      <main id={'mainPageContainer'}>
        <div className={classes.toolbar} />
        {props.isInitialized==false && <LinearProgress />}
        { props.mainPage }
        {
           !props.mainPage &&
           <MainPageContainerWithRouter
              allTopics={props.allTopics}
              latestNewsPost={props.latestNewsPost}
              headlines={props.headlines}
              amaCards={props.amaCards}
              hideSidebar={() => handleDrawerClose()}
           />
        }

      </main>
      <BottomBar />
    </div>
  );
}